import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Collapse from 'react-css-collapse';
import { find, isEqual, reduce, isNull, memoize, get, has } from 'lodash';
import { isTeachersEnabled } from 'utils/authScopes';
import PlayerQuestion from './PlayerQuestion';

const formatScore = (s, isLoading = false) => {
  if (isLoading) {
    return (
      <span>
        <i className='o-spinner-dual'></i>
      </span>
    )
  }
  const score = isNull(get(s, 'score', null)) ? '--.--' : Number(s.score).toFixed(2);
  return (
    <span>
      {score}
      {s && s.result && <br/>}
      {s && s.result && s.result}
    </span>
  )
};
const formatAligned = (a, b) => `${a}/${b}`

const getAlignedAnswersNumber = (entities, section) => {
  if (!has(section, 'score.teacher')) return 0;
  return reduce(section.questions, (sum, q) => {
    const responseId = find(entities.questions[q].responseTypes, r => entities.responseTypes[r].required && entities.responseTypes[r].inputType === 'radio');
    if (!responseId) return sum;
    const r = entities.responseTypes[responseId];
    if (isNull(r.answer.teacher) && isNull(r.answer.parent)) return sum;
    if (r.answer.teacher !== r.answer.parent && (!r.answer.teacher || !r.answer.parent)) return sum;
    return isEqual(entities.answers[r.answer.teacher].answerHandles, entities.answers[r.answer.parent].answerHandles) ? sum + 1 : sum;
  }, 0)
}

const getAnswersNumber = section => section.questions.length

export default class PlayerSection extends React.PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    state: PropTypes.string.isRequired,
    entities: PropTypes.object.isRequired,
    teacherSurvey: PropTypes.object,
    section: PropTypes.object.isRequired,
    onQuestionInfo: PropTypes.func.isRequired,
    onClickNotes: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.getAlignedAnswersNumber = memoize(getAlignedAnswersNumber);
  }

  onClick = () => {
    this.setState(p => { return { isOpen: !p.isOpen } });
  }

  render() {
    const { auth, entities, section, state, onQuestionInfo, onClickNotes, isLoading, teacherSurvey } = this.props;
    const showTeacher = isTeachersEnabled(auth);
    const clsIcon = classNames(
      [`o-player-section__icon sp-icon-caret cs-txt--sp-${state}`],
      { 'o-player-section__icon--open': this.state.isOpen,
        'o-player-section__icon--close': !this.state.isOpen }
    );
    const questions = section.questions.map((q, qIdx) => {
      const question = entities.questions[q];
      return <PlayerQuestion key={`question-${q}`} qIdx={qIdx} question={question} entities={entities} auth={auth}
        onQuestionInfo={onQuestionInfo} onClickNotes={onClickNotes} teacherSurvey={teacherSurvey} />
    });
    return (
      <div>
        <div className='o-rtable__row o-rtable__row--bt-bordered cs-bg--sp-hover u-pointer' onClick={this.onClick}>
          <div className='o-player-cell o-player-cell__header'>
            <span className='u-flex-inline align-middle'>
              <i className={clsIcon}></i><b>{section.name}</b>
            </span>
          </div>
          { showTeacher &&
            <div className='o-player-cell o-player-cell__radio'>
              {formatScore(get(section, 'score.teacher'), isLoading)}
            </div> }
          <div className='o-player-cell o-player-cell__radio'>
            {formatScore(get(section, 'score.parent', section.score))}
          </div>
          <div className='o-player-cell o-player-cell__align'>
            { showTeacher && <span>{formatAligned(this.getAlignedAnswersNumber(entities, section), getAnswersNumber(section))}</span> }
          </div>
        </div>
        <Collapse isOpen={this.state.isOpen} className='o-player-section-animation'>
          {questions}
        </Collapse>
      </div>
    );
  }
}
